exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "sui-multi-select {\n  width: 100%;\n}\n\n/* fix incorrect display in semantic grid */\n:host >>> .selection {\n  min-width: inherit !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/select-user-multiple/select-user-multiple.component.css
// module id = 864
// module chunks = 0